import { ApolloClient } from '@apollo/client';
import { SaveDocument, SaveDocumentTemplate } from '../document-interface.types';
import { graphql } from '../../../gql';

export const updateDocument: SaveDocument = (variables) => (client: ApolloClient<object>) => {
  const mutation = graphql(/* GraphQL */`
    mutation UpdateDocument($documentId: ID!, $document: Json, $title: String, $storageFormat: String) {
      updateDocument(documentId: $documentId, document: $document, title: $title, storageFormat: $storageFormat) {
        id
        status
        document
        title
        currentTeamPossession
        documentSuggestions {
          id
          externalId
          status
        }
        lastUpdated
        team {
          id
        }
        source
        importedAssetUrl
        importedAssetDownloadPath
        shouldReturnForReceiverReview
        approvalRequest {
          id
          status
          threshold
          permitEditingDuringApproval
          creator {
            id
          }
          reviewers {
            id
          }
          reviews {
            id
            approvedAt
            rejectedAt
            reviewer {
              id
              fullName
              email
            }
          }
          totalReviews
          totalApproved
        }
        isEditable
        isTitleEditable
        importedAssetContentType
        editorConfiguration
      }
    }
  `);

  return client.mutate({ mutation, variables }).then(({ data }: Record<any, any>) => data.updateDocument);
};

export const updateDocumentTemplateContentOrVisibilityOrName: SaveDocumentTemplate =
  (variables) => (client: ApolloClient<object>) => {
    const mutation = graphql(/* GraphQL */`
      mutation updateDocumentTemplateContentOrVisibilityOrName(
        $documentTemplateId: ID!
        $name: String
        $template: Json
        $hidden: Boolean
      ) {
        updateDocumentTemplate(
          documentTemplateId: $documentTemplateId
          name: $name
          hidden: $hidden
          template: $template
        ) {
          id
          name
          template
          updatedAt
          team {
            id
          }
        }
      }
    `);

    return client.mutate({ mutation, variables }).then(({ data }: Record<any, any>) => data.updateDocumentTemplate);
  };

// Draft-aware save function for template editing (autosave and title updates)
export const updateDocumentTemplateDraft: SaveDocumentTemplate = (variables) => (client: ApolloClient<object>) => {
  const mutation = graphql(/* GraphQL */`
    mutation updateDocumentTemplateDraft($documentTemplateId: ID!, $template: Json, $name: String) {
      updateDocumentTemplateDraft(documentTemplateId: $documentTemplateId, template: $template, name: $name) {
        id
        name
        template
        draftTemplate
        workingTemplate
        hasPendingChanges
        draftUpdatedAt
        updatedAt
        team {
          id
        }
      }
    }
  `);

  return client.mutate({ mutation, variables }).then(({ data }: Record<any, any>) => data.updateDocumentTemplateDraft);
};
